export default {
	// Recharge.vue
	recharge: '充值',
	rechargeTip: '①请将充值金额汇到以下汇款处。',
	rechargeTip2: '②请记载付款日期等汇款信息并发送。',
	payDate: '付款日期',
	rechargeType: '充值方式',
	tradeOrderNo: '交易订单号',
	receivingAccount: '收款银行',
	payAccount: '付款账号',
	payUser: '付款人',
	amount: '金额',
	amountJPY: '金额（円）',
	amountCNY: '金额（元）',
	viewRechargeLog: '查看充值记录',
	submitSuccessTip: '提交成功，感谢您的支持，请等待财务人员审核入账。',
	rechargeAmount: '充值金额',
	submitTime: '提交时间',
	verificationCode: '验证码',
	verificationCodeTip: '换一张',
	verificationCodeError: '验证码不正确',
	bankTransfer: '银行转账',
	alipay: '支付宝',
	wechat: '微信',
	// RechargeList.vue
	rechargeLog: '充值记录',
	userRechargeLog: '用户充值记录',
	rechargeNo: '充值流水号',
	auditing: '审核中',
	rechargeSuccess: '充值成功',
	rechargeFailed: '充值失败',
	cancelled: '已取消',
	orderOpr: '订单操作',
	tradeNo: '交易编号',
	userId: '用户ID',
	rechargeState: '充值状态',
	cancelRechargeConfirm: '确定取消本次充值记录吗',
	JPY: '日元',
	CNY: '元',
	tips: "帮我保存付款账号和付款人信息。",
	export: '导出凭证',
	queren: "请确认凭证上的姓名：",
	exchangeRate: '汇率',
	scVideo: '上传视频：',
	scFj: '上传附件：',
	yhName: '用户名：',
	rechargeConfirmButtonText:'确定',
	rechargeCancelButtonText:'不再显示',
	rechargeConfirmText:'汇款账户号码变更了。请注意不要弄错汇款。',
	chooseRechargeMethod: '选择充值方式',
	zcl40add8: '含 PayPal 支付手续费',
	rechargeDetail1: '付款通知书',
	rechargeDetail2: '账单编号',
	rechargeDetail3: '账单日期',
	rechargeDetail4: '注册号',
	rechargeDetail5: '押金补充',
	rechargeDetail6: '小计中非课税金额',
	rechargeDetail7: '消费税额 (10%)',
	rechargeDetail8: '换算汇率',
	rechargeDetail9: '现依据上述明细，向您开具本次付款账单',
	rechargeDetail10: '明细如下，特此向您申请收款',
	rechargeDetail11: '小计中应税金额（等同于我司手续费部分）',
	rechargeDetail12: '汇款账户',
	rechargeDetail13: '普通账户',
	payAmount: '付款金额'
};
